export const CardOptions = isDark => ({
	iconStyle: 'solid',
	style: {
		base: {
			iconColor: '#9EA7B3',
			color: isDark ? '#f4f5f7' : '#383838',
			'::placeholder': {
				color: '#9EA7B3',
			},
			backgroundColor: 'transparent',
			fontFamily: 'Geist',
			fontWeight: 600,
			fontSize: '16px',
			fontSmoothing: 'antialiased',
			lineHeight: '1.5em',
		},
		invalid: {
			iconColor: '#FB4E5D',
			color: '#FB4E5D',
		},
	},
});

export const ElementOptions = [
	{
		cssSrc: 'https://fonts.googleapis.com/css?family=Nunito+Sans',
	},
];

export const FontOptions = {
	cssSrc: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro',
};

// Docs
// https://stripe.com/docs/js/appendix/style
